import { useCallback } from 'react';
import { openSupportEmail } from '../utils/emailService';

export const useEmailService = () => {
  const openSupport = useCallback(() => {
    try {
      openSupportEmail();
    } catch (error) {
      console.error('Failed to open support email:', error);
      // Fallback: copy email to clipboard or show email address
      navigator.clipboard?.writeText('subwise.support@mutarelabs.com');
    }
  }, []);

  return {
    openSupport,
  };
};